<template>
  <div class="auth-frame app-aurora flex min-h-[calc(100vh-var(--app-banner-h,0px))] flex-col items-center px-4 py-10">
    <a href="https://infinite.ad" class="mb-8 no-underline">
      <app-brand-mark />
    </a>

    <main :class="[ 'glass-panel my-auto w-full rounded-2xl p-6 sm:p-10', wide ? 'max-w-xl' : 'max-w-md' ]">
      <h1
        v-if="title"
        :class="[ 'm-0 mb-6 text-2xl leading-tight font-semibold tracking-tight text-foreground', centered && 'text-center' ]"
      >
        {{ title }}
      </h1>
      <slot />
    </main>

    <div v-if="languageSelect" class="mt-8 w-48">
      <language-select />
    </div>
  </div>
</template>

<script>
import AppBrandMark from '@/ui/components/AppBrandMark.vue';
import LanguageSelect from '@/ui/components/LanguageSelect.vue';

/** Full-page frame of the pages outside the app shell (sign-in flows). */
export default {
  name: 'AuthFrame',
  components: {
    AppBrandMark,
    LanguageSelect,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: () => '',
    },
    centered: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    wide: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    languageSelect: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
};
</script>
